import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $connectionStore } from '@lib/store/integrations/connectionStore';
import { IntegrationType } from '@shared/api/rest/integrations';

export const IntegrationsCallbackPage = () => {
  const connectionStore = useUnit($connectionStore.store);

  const location = useLocation();

  useEffect(() => {
    try {
      const query = new URLSearchParams(location.search);
      if (query.has('code')) {
        const code = query.get('code');
        if (code) {
          console.log('code', code);
          $connectionStore.events.confirmConnect({
            service: IntegrationType.XERO,
            code,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  }, [location]);

  useEffect(() => {
    console.log('step', connectionStore.data);
    if (connectionStore.data === 'confirmed') {
      window.location.href = '/integrations/';
    }
  }, [connectionStore.data]);

  return null;
};
